import React from 'react';

const PageHeader = ({ companyName, accountName }) => (
    <div className="page-title-box d-sm-flex align-items-center justify-content-between mb-4">
        <div className="d-flex align-items-center flex-wrap gap-3">
            <h3 className="mb-0 text-dark me-sm-3">Tahsilat360 - Link ile Ödeme</h3>
            {(companyName || accountName) && (
                <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 mt-2 mt-sm-0">
                    {companyName && (
                        <div className="d-flex align-items-center bg-info-subtle border border-info rounded-3 py-2 px-3 shadow-sm"
                             style={{ borderColor: '#FFA500', backgroundColor: '#FFF4E6' }}>
                            <i className="bx bx-buildings text-info fs-4 me-2" style={{ color: '#CC8400' }} />
                            <h6 className="mb-0 text-muted" style={{ fontSize: '.9rem' }}>
                                Şirket: <span className="text-dark fw-bold">{companyName}</span>
                            </h6>
                        </div>
                    )}
                    {accountName && (
                        <div className="d-flex align-items-center bg-primary-subtle border border-primary rounded-3 py-2 px-3 shadow-sm">
                            <i className="bx bx-user-pin text-primary fs-4 me-2" />
                            <h6 className="mb-0 text-muted" style={{ fontSize: '.9rem' }}>
                                Cari/Bayi: <span className="text-dark fw-bold">{accountName}</span>
                            </h6>
                        </div>
                    )}
                </div>
            )}
        </div>
        <div className="page-title-right mt-3 mt-sm-0">
            <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">Ödeme</li>
                <li className="breadcrumb-item active">Link ile Ödeme</li>
            </ol>
        </div>
    </div>
);

export default PageHeader;